import type { SVGProps } from 'react'

export const GiphyMonochromeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    focusable={false}
    {...props}
  >
    <g fill="currentColor">
      <path d="M5 4.543h2v14.914H5V4.543ZM17 8.657h2v10.8h-2v-10.8Z" />
      <path d="M5 18.943h14V21H5v-2.057ZM5 3h8v2.057H5V3ZM17 7.114V5.057h-2V3h-2v6.171h6V7.114" />
      <path d="M17 11.229V9.17h2" />
    </g>
  </svg>
)
